<mat-dialog-content data-test-id="adressverwaltung-dialog-content" data-help-anchor="_die_kontaktmaske">
	<schir-int-client-adressverwaltung-kontakt-list data-test-id="adressverwaltung-kontakt-list-root"
	                                                [selectedKontakt]="selectedKontakt | async"
	                                                [editMode]="editMode | async" [searchParameters]="searchParameters"
	                                                (setSelectedKontakt)="setSelectedKontakt($event)"
	                                                (addKontakt)="addKontakt()" data-help-anchor="_suche_von_kontakten"/>
	<schir-int-client-adressverwaltung-kontakt-view data-test-id="adressverwaltung-kontakt-view-root"
	                                                [selectedKontakt]="selectedKontakt | async"
	                                                [editMode]="editMode | async" (onSubmit)="onSubmit($event)"/>
</mat-dialog-content>
<mat-dialog-actions data-test-id="adressverwaltung-dialog-actions">
	<button mat-stroked-button data-test-id="cancel-button" class="focus-inwards-dark" (click)="onCancel()">Schließen
	</button>
</mat-dialog-actions>
